module.exports = __webpack_public_path__ + "media/components/country-flag/static/bj-9e50a2013ea0e0c228d76359ed81041d.svg";